import { useMemo } from "react";
import { ThemeEditor } from "@wedding/theme-editor";
import { useWedding } from "../contexts/wedding-context";
import { createJoinThemeApi } from "../lib/api";

/**
 * Organizer adapter for the shared join-theme editor. The whole UI lives in
 * `@wedding/theme-editor` (single source of truth — admin renders the same
 * component); only the API client + wedding context are organizer-specific.
 */
export function ThemesPage() {
  const { wedding, slug, refresh } = useWedding();
  const api = useMemo(() => createJoinThemeApi(slug), [slug]);
  return <ThemeEditor slug={slug} wedding={wedding} refresh={refresh} api={api} />;
}
